import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 650px;
  width: 60%;
  margin: 0 auto;
`;
